import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { tVerModel } from 'src/app/models/non-master-model/tVerModel';
import { AppSettings } from 'src/app/shared/AppSettings';



@Injectable({
    providedIn: 'root'
})

export class tVerService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tVerModels';

    getInfoByID(id: number) {
        return this.http.get<tVerModel>(this.baseurl + this.pathName + '/' + id).pipe(shareReplay(1));
    }
}